import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Heart, Clock, ShieldCheck } from 'lucide-react';
export function Story() {
  const features = [{
    icon: <Heart className="w-6 h-6 text-brand-red" data-id="element-218" />,
    title: 'Familie Passie',
    desc: 'Opgericht in 2020 uit gemis van authentieke, exotische smaken in de dagelijkse keuken.'
  }, {
    icon: <Leaf className="w-6 h-6 text-brand-red" data-id="element-219" />,
    title: 'Puur Natuur',
    desc: '100% natuurlijke ingrediënten, zonder kunstmatige toevoegingen. Gewoon pure peper.'
  }, {
    icon: <Clock className="w-6 h-6 text-brand-red" data-id="element-220" />,
    title: 'Lange Houdbaarheid',
    desc: 'Zorgvuldig gedroogd voor een lange houdbaarheid met behoud van de intense smaak.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-red" data-id="element-221" />,
    title: 'Premium Kwaliteit',
    desc: 'Alleen de beste Madame Jeanette pepers (Capsicum chinense) worden geselecteerd.'
  }];
  return <section id="story" className="py-24 bg-white overflow-hidden" data-id="element-222">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-223">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-224">
          <div className="w-full lg:w-1/2 relative" data-id="element-225">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-2xl" data-id="element-226">
              <img src="https://cdn.magicpatterns.com/uploads/q69gSCR37sHVTDk9btsVP1/WhatsApp-Image-2026-02-03-at-10.47.30-1.jpg" alt="Capsin Madame Jeanette navullingszakjes - echte Surinaamse smaak" className="w-full h-full object-cover" loading="lazy" data-id="element-227" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-228"></div>
              <div className="absolute bottom-8 left-8 right-8 text-white" data-id="element-229">
                <p className="font-serif text-2xl italic" data-id="element-230">
                  "De naam Capsin komt voort uit de wetenschappelijke benaming
                  van de Madame Jeanette peper: Capsicum chinense."
                </p>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-brand-orange/10 rounded-full blur-3xl -z-10" data-id="element-231"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-red/10 rounded-full blur-2xl -z-10" data-id="element-232"></div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-233">
            <span className="text-brand-orange font-medium tracking-widest uppercase text-sm" data-id="element-234">
              Ons Verhaal
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-dark mt-4 mb-6" data-id="element-235">
              De Oorsprong van <br data-id="element-236" />
              Echte Smaak
            </h2>
            <p className="text-brand-gray text-lg mb-10 leading-relaxed" data-id="element-237">
              Capsin is een jong familiebedrijf dat is opgericht met één
              duidelijk doel: de authentieke, exotische smaken terugbrengen in
              de dagelijkse keuken. Onze passie voor kruiden en de liefde voor
              de Surinaamse keuken vormen de basis van elk potje dat wij vullen.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-238">
              {features.map((feature, idx) => <div key={idx} className="flex gap-4" data-id="element-239">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center" data-id="element-240">
                    {feature.icon}
                  </div>
                  <div data-id="element-241">
                    <h4 className="font-serif font-bold text-brand-dark mb-2" data-id="element-242">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-brand-gray leading-relaxed" data-id="element-243">
                      {feature.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12" data-id="element-244">
              <Link to="/contact" className="inline-block border-2 border-brand-dark text-brand-dark px-8 py-3 rounded-full font-medium hover:bg-brand-dark hover:text-white transition-colors duration-300" data-id="element-245">
                Neem contact op
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}